import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const workforceOptimizationRoute: InvariantJiraRoute = {
	name: 'servicedesk-workforce-optimization',
	path: '/jira/servicedesk/projects/:projectKey/workforce-optimization',
	exact: true,
};
